export { default } from "./SectionHeading";
